import { redirectUnauthedUser } from './redirectUnauthedUser';
import { getAccessToken } from 'src/common/external/aws/getAccessToken';
import { signOut } from 'src/common/external/aws/signOut';

const authService = {
  signOut: () => {
    signOut();
    redirectUnauthedUser();
  },
  getAccessToken,
};

export { authService };
